// @flow
import React, { Component } from "react";
import { Button, Icon, Dropdown, Menu } from "antd";
import bytes from "bytes";
import download from "downloadjs";

type Props = {
  files: Array<Object>,
  direction: string,
  label: string,
  clsName: string
};

type State = {
  placement: string,
  clsName: string
};

class DownloadBtn extends Component<Props, State> {
  state: {
    placement: string,
    clsName: string
  };

  static defaultProps = {
    direction: "down",
    label: "Download",
    clsName: "btn-grey"
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      placement: props.direction === "down" ? "bottomCenter" : "topCenter",
      clsName: props.clsName
    };
  }

  downloadFile(e: any) {
    // console.log(e.key);
    download(e.key);
  }

  menu = (
    <Menu onClick={this.downloadFile}>
      {this.props.files.map(file => {
        let size = "";
        if (file.hasOwnProperty("filesize")) {
          const sizeInt = parseInt(file.filesize, 10);
          size = ` (${bytes(sizeInt)})`;
        }
        return (
          <Menu.Item key={file.url}>
            {file.desc}
            {size} <Icon type="download" />
          </Menu.Item>
        );
      })}
    </Menu>
  );

  render() {
    return (
      <Dropdown
        overlay={this.menu}
        trigger={["click"]}
        placement={this.state.placement}
        getPopupContainer={triggerNode => triggerNode.parentNode}
      >
        <Button className={`download-btn ${this.state.clsName}`}>
          {this.props.label}
          <Icon
            type="download"
            style={this.props.label === "" ? { marginLeft: 0 } : null}
          />
        </Button>
      </Dropdown>
    );
  }
}

export default DownloadBtn;



// WEBPACK FOOTER //
// ./src/components/downloadbtn/index.js